module.exports = __webpack_public_path__ + "static/media/multispan.94c9a13a.webp";